module.exports = __webpack_public_path__ + "f2a63db4aeab018646865b35915f5c1a.pdf";